<template>
<div>
    <base-button 
        class="col-12 mr-0" 
        type="warning"
        @click="modal = true"
    >{{ $t('login.email_change') }}
    </base-button>
    <modal v-model:show="modal" footerClasses="d-flex justify-content-center">
        <template #header><div class="text-muted text-center">{{ $t('login.email_reset') }}</div></template>
        <template v-if="true">
            <base-input
                v-model="email"
                v-validate.disable="'required|email'"
                :name="$t('login.email')"
                :placeholder="$t('login.email')"
                :error="errors.first($t('login.email'))"
                prepend-icon="ni ni-email-83"
                type="email"
            ></base-input>
            <base-input
                v-model="email_confirmation"
                v-validate.disable="{ is: email, required: true }"
                :name="$t('login.email')"
                :placeholder="$t('login.email_confirmation')"
                :error="errors.first($t('login.email'))"
                prepend-icon="ni ni-email-83"
                type="email"
            ></base-input>
        </template>
            <template #footer><base-button
                @click.stop="submit"
                :loading="loading" 
                type="success"
                class="mb-3"
            >
                {{ $t('login.email_change') }}
            </base-button></template>
    </modal>
</div>
</template>

<script>
import BaseButton from '../../argon/components/BaseButton'
import BaseInput from '../../argon/components/Inputs/BaseInput'
import Modal from '../../argon/components/Modal'

export default {
    name: 'ProfileChangeEmail',
    props: {
        color: {
            type: Object,
            required: true
        },
        userId: {
            type: Number,
            required: true
        }
    },
    components: {
        BaseButton,
        BaseInput,
        Modal
    },
    data() {
        return {
            modal: false,
            email: '',
            email_confirmation: '',
            loading: false
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true

                    window.axios.patch(`/api/app/profile/email`, {
                        id: this.userId,
                        email: this.email
                    })
                    .then(res => {
                        this.$emit('updatedEmail', this.email)
                        this.$notify({ type: 'success', message: res.data.message }) 
                    })
                    .catch(err => {
                        const errors = err.response.data.errors
                        errors.map(error => this.$notify({ type: 'danger', message: error }))
                    })
                    .finally(() => {
                        this.loading = false
                        this.modal = false
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>
